<div class="row events" #events>
    <div class="hotel" *ngFor="let item of itemList">
      <div class="inner-card">
        <img src={{item.image}} />
      </div>
      <p class="title">
        {{item.title}}
      </p>
      <a href="#">Find out More</a>
    </div>
  </div>
